import { XIcon } from "@heroicons/react/outline";
import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { getMiniCRMNWEASchools } from "../../../../api/miniCrm.service";
import { updateNWEASchoolId } from "../../../../api/school.service";
import Loader from "../../../shared/loader/loader";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function NWEASchoolSearch(props: any) {
  const [loading, setLoading] = useState<boolean>(false);
  const [schoolName, setSchoolName] = useState<string>("");
  const [schools, setSchools] = useState<Array<any>>([]);
  const [totalRecord, setTotalRecord] = useState(-1);

  async function handleUpdateNWEAId(nweaId: string) {
    if (nweaId) {
      await updateNWEASchoolId(
        props.schoolId,
        nweaId,
        props?.profile?.userId ?? 0
      );
      toast.success("School NWEA Id updated successfully");
      props?.handleSchoolSearchModalOpen();
    } else {
      toast.error("School NWEA Id should not be empty");
    }
  }
  function handleSchoolSearch() {
    getSchoolDetail(schoolName);
  }
  async function getSchoolDetail(schoolName) {
    setLoading(true);
    const params: any = {
      schoolName: schoolName,
      pageSize: 100,
      pageNumber: 1,
    };
    const resp = await getMiniCRMNWEASchools(params);

    if (resp && resp.data && resp.data.data && resp.data.data.length > 0) {
      setSchools(resp.data.data);
      setLoading(false);
      setTotalRecord(resp.data.totalRecords);
    } else {
      setTotalRecord(resp.data.totalRecords);
    }
  }
  return (
    <Fragment>
      {loading && <Loader />}
      <div className="fixed inset-0 z-40 flex items-center bg-black bg-opacity-50 sm:items-center sm:justify-center">
        <div
          className="w-full flex flex-col justify-between overflow-hidden bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4 sm:max-w-5xl"
          role="dialog"
        >
          <header>
            {/* Header */}
            <div className="px-4 py-4 bg-gray-50">
              <div className="flex items-start justify-between space-x-3">
                <div className="space-y-1">
                  <div className="text-lg font-medium text-gray-900">
                    <h2 className="text-xl mb-2">Search Schools </h2>
                  </div>
                </div>
                <div className="h-7 flex items-center">
                  <button
                    type="button"
                    className="text-gray-400 hover:text-gray-500"
                    onClick={() => props.handleSchoolSearchModalOpen()}
                  >
                    <span className="sr-only">Close panel</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </header>
          <div className="w-full relative  px-4 py-6">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-6 sm:col-span-6">
                <label className="text-sm text-gray-700">School Name</label>
                <div className="flex flex-row items-center contentArea">
                  <input
                    id="schoolName"
                    name="schoolName"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    value={schoolName}
                    onChange={(e) => setSchoolName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-span-3 sm:col-span-3 mt-3">
                <button
                  type="button"
                  onClick={handleSchoolSearch}
                  className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                >
                  Search
                </button>
              </div>
            </div>
            <div className="mt-4 h-[20rem] overflow-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-primary-color">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                    >
                      School Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                    >
                      District Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                    >
                      School BId
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  {schools.map((school, index) => (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "bg-white " : "bg-gray-100"}
                    >
                      <td>{school.name}</td>
                      <td>{school.districtName}</td>
                      <td>{school.nweaId}</td>
                      <td>
                        {" "}
                        <button
                          type="button"
                          disabled={school.isNWEAIdMapped}
                          title={
                            school.isNWEAIdMapped
                              ? "This NWEA Id is already mapped to another school."
                              : "Please select to map this NWEA Id to school."
                          }
                          onClick={() => handleUpdateNWEAId(school.nweaId)}
                          className={classNames(
                            "disabled:opacity-50 mt-2 mb-2 inline-flex items-center text-sm gap-2  py-1.5 px-4 rounded-lg",
                            school.isNWEAIdMapped
                              ? "bg-gray-200 cursor-not-allowed text-gray-700 border border-gray-500"
                              : "bg-primary-color hover:bg-secondary-color text-white dark:text-white "
                          )}
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                  {schools && totalRecord === 0 && (
                    <tr className="bg-gray-100">
                      <td className="p-2" colSpan={4}>
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* <!-- Action Buttons -->  */}
          <footer className="flex flex-col items-center justify-end px-6 py-4 sm:flex-row bg-gray-50 dark:bg-gray-800">
            <div className="flex-shrink-0">
              <div className="flex justify-end pt-4">
                <button
                  type="button"
                  className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  onClick={() => props?.handleSchoolSearchModalOpen()}
                >
                  <span>Cancel</span>
                </button>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </Fragment>
  );
}
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(NWEASchoolSearch);
